import React from 'react';

import PropTypes from 'prop-types';

const Progress = (props) => {
  const { id, value, background, rounded } = props;

  return (
    <svg
      id={`bar_${id}`}
      className="progressBar"
      style={{
        backgroundColor: background === true ? '#000' : background,
        borderRadius: rounded === true ? '5rem' : rounded,
      }}
      viewBox="0 1 100 1"
      preserveAspectRatio="none"
    >
      <path id={`bar_path_${id}`} d={`M0 1 L${value} 1`} className="progressValue" />
    </svg>
  );
};

export default Progress;

Progress.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  value: PropTypes.number,
  background: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  rounded: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
};

Progress.defaultProps = {
  value: 0,
  background: null,
  rounded: null,
};
